import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

import type { SupplierNetworkConnection } from "../components/SupplierNetwork/types";

interface UseSupplierNetworkReturn {
  data: SupplierNetworkConnection[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useSupplierNetwork(): UseSupplierNetworkReturn {
  const { role } = useRoleContext();

  if (role && role.type !== "SHIPPER") {
    throw new Error("useSupplierNetwork can only be used by shipper users");
  }

  const url = role ? `/shippers/${role.id}/suppliers` : null;

  const { data, loading, error, refetch } = useSwrFetch<
    SupplierNetworkConnection[]
  >({
    url,
    errorMessage: "Failed to fetch supplier network data",
  });

  return {
    data: data ?? [],
    loading,
    error,
    refetch,
  };
}
